import { FileField, FileInputClasses } from 'react-admin';
import { useTheme } from '@mui/material';
import { useTranslate } from 'ra-core';
import { ImageInput, ImageInputProps } from '../../../../components/inputs/ImageInput';

export const CertificationDocumentInput = (props: ImageInputProps) => {

  const theme = useTheme();
  const translate = useTranslate();
  return (
    <ImageInput
      {...props}
      removeIcon={() => (
        <span style={{
          fontSize: '12px',
          fontWeight: 'bold',
          color: theme.palette.error.main,
          textDecoration: 'underline',
          padding: 2,
        }}>
          {translate('ra.input.image.remove_current')}
        </span>
      )}
      sx={{
        [`& .previews .${FileInputClasses.removeButton}`]: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: 1,
          paddingTop: 1,
        },
        [`& .previews .${FileInputClasses.removeButton} button`]: {
          opacity: 1,
          position: 'static',
          top: 'unset',
          right: 'unset',
          order: 2,
          padding: 0,
          '&:hover': {
            borderRadius: 1,
          },
        },
        '& .previews .RaFileField-root': {
          order: 1,
          flex: 'none',
          minWidth: 0,
        },
        ...props.sx,
      }}
    >
      <FileField source="src" title="title" />
    </ImageInput>
  );

};
